var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ready-to-launch" }, [
    _c("h2", [_vm._v("Quick Review")]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "campaign-overview" }, [
          _c("h3", [_vm._v("Campaign Overview")]),
          _c("div", { staticClass: "campaign-overview-list" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-10 offset-md-1" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("h4", [_vm._v("Campaign Name")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.campaign_name))
                    ]),
                    _c("h4", [_vm._v("Num of Activities")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.total_activity_count))
                    ]),
                    _c("h4", [_vm._v("Budget")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.campaign_budget))
                    ]),
                    _c("h4", [_vm._v("Incentive Type")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.incentive_type))
                    ]),
                    _c("h4", [
                      _vm._v("Start-Date - "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.getCampaignDetail.start_date))
                      ])
                    ]),
                    _c("h4", [
                      _vm._v("End-Date - "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.getCampaignDetail.end_date))
                      ])
                    ]),
                    _c("h4", [_vm._v("Unlock Code")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.unlock_code))
                    ])
                  ]),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("h4", [_vm._v("Geo-Location Type")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.geo_location_type))
                    ]),
                    _c("h4", [_vm._v("Single User Limit")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.single_user_limit))
                    ]),
                    _c("h4", [_vm._v("Incentives")]),
                    _c("h6", [_vm._v(_vm._s(_vm.getCampaignDetail.coupon))]),
                    _c("h4", [_vm._v("Package of Benefit")]),
                    _c("h6", [_vm._v(_vm._s(_vm.getCampaignDetail.package))]),
                    _c("h4", [_vm._v("Buy Me Activity")]),
                    _c("h6", [_vm._v("Not available for freemium")])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm.getCampaignDetail.status == "Awaiting Approval"
          ? _c("div", { staticClass: "action_button_box" }, [
              _c(
                "button",
                {
                  staticClass: "Reject_button",
                  on: {
                    click: function($event) {
                      return _vm.rejectCamp(_vm.getCampaignDetail.pickl_id)
                    }
                  }
                },
                [_vm._v("Reject")]
              ),
              _c(
                "button",
                {
                  staticClass: "Approve_button",
                  on: {
                    click: function($event) {
                      return _vm.approveCamp()
                    }
                  }
                },
                [_vm._v("Approve")]
              )
            ])
          : _vm._e()
      ]),
      _c("div", { staticClass: "col-md-4" }, [
        _vm.showProductPreview
          ? _c(
              "div",
              {
                class: [
                  "preview NewPrevAct",
                  { "scrolled-fix": _vm.isScrolled }
                ]
              },
              [
                _c("div", { staticClass: "store_brand" }, [
                  _c("img", {
                    staticClass: "left_brand",
                    attrs: { src: _vm.getStoreDetail.img }
                  }),
                  _c("h6", [_vm._v(_vm._s(_vm.brandInfo.name))]),
                  _c("img", {
                    staticClass: "right_brand",
                    attrs: { src: _vm.brandInfo.logo }
                  })
                ]),
                _c(
                  "div",
                  { staticClass: "mapBox" },
                  [
                    _c("h5", [
                      _vm._v('"' + _vm._s(_vm.getStoreDetail.name) + '"')
                    ]),
                    _c("h6", [
                      _vm._v(
                        "Category: " + _vm._s(_vm.previewProductDetail.name)
                      )
                    ]),
                    _c("ChartTemp", {
                      attrs: {
                        codes: _vm.selectedStatesCodes || {},
                        retailerImage: _vm.getStoreDetail.img
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "brand_intro" }, [
                  _c("div", { staticClass: "brand_desc" }, [
                    _c(
                      "div",
                      {
                        staticClass: "brand_header",
                        staticStyle: { float: "left" }
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm.previewProductDetail.img }
                        }),
                        _c(
                          "h6",
                          {
                            staticStyle: {
                              "text-align": "left",
                              color: "#000",
                              "font-size": "15px",
                              "font-weight": "500"
                            }
                          },
                          [_vm._v(_vm._s(_vm.previewProductDetail.name))]
                        ),
                        _c("p", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(_vm._s(_vm.previewProductDetail.description))
                        ])
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-weight": "500",
                          "font-size": "14px",
                          color: "#000",
                          "text-align": "left",
                          float: "left",
                          width: "100%",
                          "margin-bottom": "7px"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.mixTasks.length
                              ? "Activities"
                              : "Image Requirements"
                          )
                        )
                      ]
                    ),
                    _c(
                      "ul",
                      {
                        staticStyle: {
                          "max-height": "210px",
                          overflow: "hidden",
                          "padding-left": "6px",
                          "list-style": "none"
                        }
                      },
                      _vm._l(_vm.previewTasks, function(task, index) {
                        return _c(
                          "li",
                          {
                            key: task.id || index,
                            staticStyle: {
                              "font-size": "14px",
                              "margin-bottom": "6px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.getTaskDisplayName(task)))]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ]
            )
          : _vm.showVideoPreview
          ? _c(
              "div",
              {
                class: [
                  "preview cr_page newPrev",
                  { "scrolled-fix": _vm.isScrolled }
                ]
              },
              [
                _c("div", { staticClass: "logoHeadBox" }, [
                  _c("div", { staticClass: "newPrevLogo" }, [
                    _c("img", {
                      staticStyle: {
                        "max-width": "100%",
                        "border-radius": "50%"
                      },
                      attrs: { src: _vm.brandInfo.logo }
                    })
                  ]),
                  _c("div", { staticClass: "newPrevHead" }, [
                    _vm._v(" " + _vm._s(_vm.brandInfo.name) + " ")
                  ])
                ]),
                _c("div", { staticClass: "yourVideo" }, [
                  !_vm.previewVideoId
                    ? _c("h5", [_vm._v("Your Video")])
                    : _c("span", [
                        _c("iframe", {
                          attrs: {
                            width: "100%",
                            height: "120px",
                            src:
                              "https://www.youtube.com/embed/" +
                              _vm.previewVideoId,
                            title: "YouTube video player",
                            frameborder: "0",
                            allow:
                              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                            referrerpolicy: "strict-origin-when-cross-origin",
                            allowfullscreen: ""
                          }
                        })
                      ])
                ]),
                _c("div", { staticClass: "mediaDesc" }, [
                  _c("h4", [_vm._v("Description")]),
                  _c("p", { staticStyle: { "text-align": "left" } }, [
                    _vm._v(_vm._s(_vm.previewMediaDescription))
                  ])
                ]),
                _vm.mixTasks.length
                  ? _c("div", { staticClass: "mixTaskList" }, [
                      _c("h4", [_vm._v("Activities")]),
                      _c(
                        "ul",
                        _vm._l(_vm.mixTasks, function(activity, index) {
                          return _c("li", { key: activity.id || index }, [
                            _vm._v(_vm._s(_vm.getTaskDisplayName(activity)))
                          ])
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }